import React from "react";
import { Carousel, Typography } from "@material-tailwind/react";
import bg1 from "../Assets/hero/bg1.JPG";
import bg2 from "../Assets/hero/bg2.JPG";
import bg3 from "../Assets/hero/bg3.JPG";
import bg4 from "../Assets/hero/bg4.JPG";
import bg5 from "../Assets/hero/bg5.JPG";

import Navbar from "../Layout/Navbar";

const Hero = () => {
  const pics = [bg1, bg2, bg3, bg4, bg5];
  return (
    <div className='relative'>
      <div className='fixed w-screen z-10 '>
        <Navbar />
      </div>

      <div className='z-'>
        <Carousel
          autoplayDelay={5000}
          autoplay={true}
          transition={{ duration: 1 }}
          loop={true}
          className=''
          navigation={({ setActiveIndex, activeIndex, length }) => (
            <div className='absolute bottom-4 left-2/4 z-50 flex -translate-x-2/4 gap-2'>
              {new Array(length).fill("").map((_, i) => (
                <span
                  key={i}
                  className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${
                    activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"
                  }`}
                  onClick={() => setActiveIndex(i)}
                />
              ))}
            </div>
          )}
        >
          {pics.map((data, index) => (
            <div className='realative w-screen h-screen'>
              <img
                src={data}
                alt='image 1'
                className='h-screen w-screen object-cover '
              />
              <div className='absolute inset-0 grid h-full w-full place-items-center bg-black/60 md:bg-black/0 '>
                <div className='w-3/ text-center md:w-3/4 px-2'>
                  <Typography
                    variant='h1'
                    color='white'
                    className='mb-4 text-xl md:text-4xl lg:text-5xl'
                  >
                    EMPOWERING REGENERATIVE LEADERS THROUGH OUR EDUCATIONAL
                    CENTRES
                  </Typography>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Hero;
